var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.getMainClass(),
      style: _vm.getMainStyle(),
      attrs: { id: _vm.getMainId() }
    },
    [
      _vm.loading
        ? _c("div", { staticClass: "loading d-flex" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      !_vm.noScrollFix
        ? _c("div", { staticClass: "overflow-fix-container" }, [
            _c("div", { staticClass: "overflow-fix" })
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "loading-dots justify-content-center align-self-center" },
      [
        _c("div", { staticClass: "dot" }),
        _vm._v(" "),
        _c("div", { staticClass: "dot" }),
        _vm._v(" "),
        _c("div", { staticClass: "dot" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-333ea9dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-333ea9dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/index.vue
// module id = null
// module chunks = 